
import { useState } from "react";
import { Form } from "@/components/dashboard/shops/types";

export const useFormTabsNavigation = (
  setCurrentForm: (form: Form | null) => void,
  setIsEditing: (value: boolean) => void,
  currentForm: Form | null,
  setFormName: (value: string) => void,
  setCtaButtonText: (value: string) => void,
  setFormProductIds: (ids: string[]) => void
) => {
  const [activeTab, setActiveTab] = useState("forms");
  
  // Function to select a form and switch to editor tab
  const handleFormSelect = (form: Form) => {
    setCurrentForm(form);
    setActiveTab("editor");
    // Automatically enable editing mode when selecting a form
    setIsEditing(true);
  };
  
  // Function to cancel editing
  const handleCancelEdit = () => {
    if (currentForm) {
      // Reset fields to original form values
      setFormName(currentForm.name);
      setCtaButtonText(currentForm.cta_button_text);
      setFormProductIds(currentForm.product_ids || []);
      setIsEditing(false);
      setActiveTab("forms");
    } else {
      // If canceling creation of a new unsaved form
      setIsEditing(false);
      setActiveTab("forms");
    }
  };
  
  return {
    activeTab,
    setActiveTab,
    handleFormSelect,
    handleCancelEdit
  };
};
